import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	border-radius: var(--radius-xs);

	gap: var(--gap-x5);
	a {
		all: revert;
	}
`;
